import { SummaryPart } from '@pkg/types/interview'

type ScorecardPartForCopy = Pick<
  SummaryPart,
  'name' | 'text' | 'score' | 'CustomSummaryPartPrompt'
>

function formatScorecardPartTitle(
  part: Pick<SummaryPart, 'name' | 'score' | 'CustomSummaryPartPrompt'>,
): string {
  const hasScore =
    part.score !== null &&
    part.score !== undefined &&
    part.CustomSummaryPartPrompt?.hasScoring === true

  if (hasScore) {
    return `${part.name} - ${part.score}/5`
  }

  return part.name
}

function cleanScorecardText(text: string): string {
  return text.replace(/\*\*\+\*\*/g, '+').replace(/\*\*-\*\*/g, '-')
}

export function formatScorecardPartForCopy(part: ScorecardPartForCopy): string {
  return formatScorecardPartTitle(part) + '\n' + cleanScorecardText(part.text)
}
